import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, query, where, getDocs, doc, updateDoc, deleteDoc } from 'firebase/firestore';
import './TradeList.css';

const UserBetsSummary = () => {
  const [userData, setUserData] = useState({
    username: '',
    tshBalance: 0,
    usdtBalance: 0,
  });

  const [bets, setBets] = useState([]);
  const [cancellingId, setCancellingId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const username = localStorage.getItem('username');
      if (!username) return;

      try {
        const userQuery = query(collection(db, 'users'), where('username', '==', username));
        const userSnapshot = await getDocs(userQuery);

        if (!userSnapshot.empty) {
          const userDoc = userSnapshot.docs[0].data();
          setUserData({
            username: userDoc.username || '',
            tshBalance: Number(userDoc.tshBalance) || 0,
            usdtBalance: Number(userDoc.usdtBalance) || 0,
          });
        }

        const betsQuery = query(collection(db, 'userBets'), where('username', '==', username));
        const betsSnapshot = await getDocs(betsQuery);

        const fetchedBets = betsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const activeBets = fetchedBets.filter((b) => !b.status);
        setBets(activeBets);

      } catch (err) {
        console.error('Failed to fetch data:', err);
      }
    };

    fetchData();
  }, []);

  const handleCancelBet = async (bet) => {
    if (cancellingId) return;

    setCancellingId(bet.id);

    try {
      const userQuery = query(collection(db, 'users'), where('username', '==', userData.username));
      const userSnapshot = await getDocs(userQuery);

      if (!userSnapshot.empty) {
        const userRef = doc(db, 'users', userSnapshot.docs[0].id);
        const userDoc = userSnapshot.docs[0].data();

        let newTshBalance = Number(userDoc.tshBalance) || 0;
        let newUsdtBalance = Number(userDoc.usdtBalance) || 0;

        if (bet.currency === 'TSH') {
          newTshBalance += Number(bet.betAmount);
        } else if (bet.currency === 'USDT') {
          newUsdtBalance += Number(bet.betAmount);
        }

        await updateDoc(userRef, {
          tshBalance: newTshBalance,
          usdtBalance: newUsdtBalance,
        });

        await deleteDoc(doc(db, 'userBets', bet.id));

        setUserData({
          ...userData,
          tshBalance: newTshBalance,
          usdtBalance: newUsdtBalance,
        });

        setBets(bets.filter((b) => b.id !== bet.id));
      }
    } catch (err) {
      console.error('Failed to cancel bet:', err);
    } finally {
      setCancellingId(null);
    }
  };

  return (
    <div className="betting-wrapper">

      {/* LIST YA BETS */}
      {bets.map((bet) => {
        const betTime = new Date(bet.betTime);
        const now = new Date();
        const diffMinutes = (now - betTime) / (1000 * 60);
        const canCancel = diffMinutes <= 15;

        return (
          <div key={bet.id} className="match-card">

            <h3 className="match-title">⚽ AntBet — Ant Score match</h3>

            <div className="teams-row">
              <span className="team-name">{bet.teamA}</span>
              <span className="vs">VS</span>
              <span className="team-name">{bet.teamB}</span>
            </div>

            <p className="match-date">{bet.matchDate} Time{bet.matchTime}</p>

            <div className="score-box">
              <span className="score-value">{bet.selectedScore}</span>
            </div>

            <p className="odds-text">
              Odds: <span className="odds-red">{Number(bet.odds).toFixed(2)}%</span>
            </p>

            <div className="ticket-row">
              {canCancel ? (
                <button
                  className="cancel-btn"
                  disabled={cancellingId === bet.id}
                  onClick={() => handleCancelBet(bet)}
                >
                  {cancellingId === bet.id ? 'Canceled...' : 'CANCEL'}
                </button>
              ) : (
                <span className="expired">⏰ Time expired</span>
              )}
            </div>

            <p className="bet-time">Time: {betTime.toLocaleString()}</p>

            <div className="result-box">
              <p>
                <span className="label">Amount:</span>
                <span className="value">
                  {Number(bet.betAmount).toLocaleString()} {bet.currency}
                </span>
              </p>

              <p>
                <span className="label">Profit:</span>
                <span className="value green">
                  {Number(bet.payout).toLocaleString()} {bet.currency}
                </span>
              </p>
            </div>

          </div>
        );
      })}
    </div>
  );
};

export default UserBetsSummary;